import { Fragment } from 'react/jsx-runtime';
import { blogClientComponents } from '@/server/lib/blog-client-components';
import type { BlogPostSummaryType } from './blog-types';

type Props = {
  detailPage: {
    readonly htmlParts: ReadonlyArray<string>;
    readonly banners: ReadonlyArray<string>;
    readonly oldPostFormat: BlogPostSummaryType;
  };
};

export function BlogContent(props: Props) {
  const { detailPage } = props;

  return (
    <article className='wp-embed-responsive prose-iframe:aspect-video prose-iframe:w-full prose-iframe:max-w-full prose max-w-none prose-neutral dark:prose-invert prose-figure:my-8 prose-figcaption:text-sm prose-figcaption:text-neutral-500 prose-img:block prose-img:h-auto prose-img:max-w-full prose-video:w-full prose-video:max-w-full'>
      {detailPage.htmlParts.map((part, index) => (
        <Fragment key={`blog-part-${index.toString()}`}>
          {/* <Fragment dangerouslySetInnerHTML={{ __html: part }} /> */}
          <div dangerouslySetInnerHTML={{ __html: part }} />
          {index < detailPage.banners.length &&
            (detailPage.banners[index] === 'CTABannerMd' ? (
              <blogClientComponents.CtaBannerMd />
            ) : (
              <blogClientComponents.FreeTrialBanner />
            ))}
        </Fragment>
      ))}
    </article>
  );
}
